import { useState, useEffect, useRef } from "react";
import { getPrecision } from "../../../utils/tillHelpers";
import { Modal, Spin, message } from "antd";
import { LoadingOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import "react-aspect-ratio/aspect-ratio.css";
import "../../style.css";
import "./styles.css";
import "../../globalStyles.css";
import data from "../../../constants/retailPos.json";
import { useWindowDimensions } from "../../../lib/useViewport";
import BarCodeComponentForRetail from "../../../lib/BarCodeComponentForRetail";
import db from "../../../database";
import { v4 as uuidv4 } from "uuid";
import { processSync } from "../../Sync/syncData";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import useTransactionStore from "../../../stores/useTransactionStore";
import RetailModals from "./RetailModals";
import CartPage from "./CartPage";
import SidebarNav from "./SidebarNav";
import ParkedBillsView from "./ParkedBillsView";
import CashManagementView from "./CashManagementView";
import SalesHistoryView from "./SalesHistoryView";
import PaymentView from "./PaymentView";
import useSalesReturn from "./useSalesReturn";

const PointOfSaleRetail = (props) => {
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const {
    addProduct,
    cart,
    setCart,
    deleteCart,
    deleteProduct,
    loader,
    onBarcodeInput,
    openDisplayParkedBillModal,
    parkBill,
    productsList,
    setProductsList,
    selectProductInCart,
    selectProduct,
    selectedProductInCart,
    selectedRowKeys,
    selectedKeys,
    setIsQtyUpdate,
    setIsSearchProducts,
    showOrderHistory,
    tillData,
    setManualDiscountInput,
    setManualDiscountModalVisible,
    posLogActivity,
    handleParkedBillSearchInput,
    searchParkedBill,
    parkedBillSearchInput,
    filterdParkedList,
    discardParkedBill,
    selectParkedBill,
    setAddCashFlag,
    setOrderHistoryInput,
    searchOrderHistory,
    changeOrderHistorySearchType,
    orderHistorySearchInputRef,
    orderHistoryDetails,
    paymentProcessFlag,
    setPaymentProcessFlag,
    tillDataPaymentMethods,
    requestPayment,
    paymentCardRef,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    amount,
    onChangeAmount,
    paymentModalInputRef,
    processOrder,
    paymentModalLoyalityMessages,
    handleAmount,
    setCashAddInFlag,
    addCashFlag,
    isPrintModeXML,
    setSelectedKeys,
    setDisplayReturnOrderSearch,
    displayReturnOrderSearch,
    setIsProductsVisible,
    setAmount,
    pickProduct,
    selectProductToCart,
    salesHistoryLoading,
  } = props;

  const [keyValue, setKeyValue] = useState("0");
  const { width } = useWindowDimensions();
  const [cashManagementData, setCashManagementData] = useState(false);
  const [productArray, setProductArray] = useState([...productsList]);
  const [productItems, setProductItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentType, setPaymentType] = useState(tillDataPaymentMethods);
  const [event, setEvent] = useState("");

  // Sales-return logic extracted into hook
  const salesReturn = useSalesReturn({
    cart,
    setCart,
    addProduct,
    posLogActivity,
    setDisplayReturnOrderSearch,
    setKeyValue,
    setProductsList,
    productsList,
    loader,
  });

  const {
    showReturnPurchase,
    setShowReturnPurchase,
    retrunSearchType,
    returnBillSearchInputRef,
    returnProcessRef,
    columns1,
    dataSource,
    modalEditState,
    setModalEditState,
    selectedReturnOrder,
    returnProcessLoading,
    setReturnProcessLoading,
    searchReturnHistory,
    handleSave,
    addSelectedReturnProductsToCart,
  } = salesReturn;

  const ref = useRef(null);

  const handleKey = (e) => {
    const { altKey, keyCode } = e;
    if (altKey && keyCode === 82) {
      if (posConfig?.showSalesReturn === "Y") {
        setDisplayReturnOrderSearch(true);
      }
    }
  };

  useEffect(() => {
    let methods = [];
    tillDataPaymentMethods.map((item) => {
      if (item.name === "Cash" && posConfig?.enableCash === "Y") {
        methods.push(item);
      } else if (item.name === "Card" && posConfig?.enableCard === "Y") {
        methods.push(item);
      } else if (item.name !== "Cash" && item.name !== "Card") {
        methods.push(item);
      }
    });
    setPaymentType(methods);
    if (!useTransactionStore.getState().salesReturn) {
      useTransactionStore.getState().setSalesReturn("N");
    }
    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, []);

  useEffect(() => {
    if (displayReturnOrderSearch) {
      setTimeout(() => {
        returnBillSearchInputRef.current.focus();
      }, 100);
    }
  }, [retrunSearchType, displayReturnOrderSearch]);

  useEffect(() => {
    const run = async () => {
      filterdParkedList?.map((item) => {
        item.key = uuidv4().replace(/-/g, "").toUpperCase();
      });
      if (paymentProcessFlag === false) {
        productsList.map((item) => {
          item.selected = "N";
        });
        setProductsList(productsList);
        setTimeout(() => {
          setKeyValue("0");
        }, 1000);
      }
      if (posConfig?.allowSplitTender === "N") {
        setAmount(cart.total);
      }
    };
    run();
  }, [paymentProcessFlag]);

  useEffect(() => {
    const run = async () => {
      let data = await db.cashInCashOut.toArray();
      setCashManagementData(data);
    };
    run();
  }, [addCashFlag]);

  orderHistoryDetails.map((item) => {
    item.name = item.customer.name;
    item.total = Number(item.total).toFixed(getPrecision(tillData));
    item.status = item.isSynced === 1 ? "Success" : "Pending";
  });

  const removeProductModal = (record) => {
    deleteProduct(record);
  };

  const deleteProductModal = () => {
    if (cart.items.length > 0) {
      Modal.confirm({
        title: "This action will remove all products from the cart, including the selected customer.Do you wish to proceed?",
        icon: null,
        cancelText: "No",
        okText: "Yes",
        okButtonProps: { style: { display: "inline-block" } },
        onOk() {
          deleteCart(true);
          setEvent("");
        },
      });
    }
  };

  const selectdata = (e) => {
    if (e === "discount") {
      setManualDiscountModalVisible(true);
      setManualDiscountInput("");
    } else if (e === "parkBill") {
      openDisplayParkedBillModal();
      setEvent("");
    } else if (e === "clearCart") {
      productsList.map((ele) => {
        ele.selected = "N";
      });
      setProductsList(productsList);
      deleteProductModal();
    }
  };

  const handleKeyvalue = async (key) => {
    if (cart.items.length <= 0) {
      productsList.map((ele) => {
        ele.selected = "N";
      });
      setProductsList(productsList);
    }
    if (key === "0") {
      setSelectedPaymentMethod({});
      setKeyValue("0");
      setSelectedKeys([]);
    }
    if (key === "1") {
      filterdParkedList?.map((item) => {
        item.status = "Parked";
        item.key = uuidv4().replace(/-/g, "").toUpperCase();
        item.customer = item.parkedCart.customer.name;
        item.qty = item.parkedCart.totalQty;
      });
      setKeyValue("1");
      setSelectedKeys([]);
    }
    if (key === "2") {
      setKeyValue("2");
      setSelectedKeys([]);
    }
    if (key === "3") {
      showOrderHistory();
      setKeyValue("3");
      setSelectedKeys([]);
    }
    if (key === "4") {
      setLoading(true);
      try {
        await db.productCategories.clear();
        await db.AllProductCategories.clear();
        await db.products.clear();
        // BUG-2638: pricingRules stays until syncPricingRules() replaces it (see deletePreviousData in Sync/syncData.js).
        await db.posSaletypes.clear();
        await db.productUom.clear();
        await db.rfidData.clear();
        await processSync();
      } catch (e) {
        console.warn("[ManualSync] Full sync failed:", e?.message);
        message.error("Sync failed. Please check your network and try again.");
      }
      setLoading(false);
    }
    if (key === "7") {
      setKeyValue("7");
      setPaymentProcessFlag(false);
      setSelectedKeys([]);
    }
    if (key === "parked-bill") {
      filterdParkedList?.map((item) => {
        item.status = "Parked";
        item.key = uuidv4().replace(/-/g, "").toUpperCase();
        item.customer = item.parkedCart.customer.name;
        item.qty = item.parkedCart.totalQty;
      });
    }
  };

  const retrieveParkedData = (record) => {
    if (cart.items.length > 0) {
      Modal.confirm({
        title: "Save Cart Items ?",
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            You can retrieve the bill later by selecting the 'Retrieve' option in Parked Bills.
            <br />
            Do you want to continue parking the bill?
          </div>
        ),
        okText: "Yes",
        cancelText: "No",
        okButtonProps: { style: { display: "inline-block" } },
        onOk() {
          parkBill();
          setTimeout(() => {
            selectParkedBill(record, "management");
          }, 2000);
        },
        onCancel() {
          selectParkedBill(record, "management");
        },
      });
    } else {
      selectParkedBill(record, "management");
    }
  };

  const handleExpand = (expanded, record) => {
    if (expanded) {
      selectProduct(record);
    } else {
      setSelectedKeys([]);
    }
  };

  const componentProps = {
    handleExpand,
    retrieveParkedData,
    handleKeyvalue,
    selectdata,
    deleteProductModal,
    setManualDiscountModalVisible,
    setManualDiscountInput,
    removeProductModal,
    handleKey,
    ref,
    width,
    productItems,
    setProductItems,
    productArray,
    setProductArray,
    paymentType,
    tillDataPaymentMethods,
    paymentCardRef,
    cashManagementData,
    filterdParkedList,
    orderHistoryDetails,
    setIsProductsVisible,
    setIsQtyUpdate,
    setEvent,
    pickProduct,
    selectProductToCart,
    event,
    ...props,
  };

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#fff" }} spin />} spinning={loading}>
      <div style={data.posScreenStyles.main}>
        <BarCodeComponentForRetail onScan={onBarcodeInput} />
        <div style={{ display: "flex" }}>
          {keyValue !== "7" && <SidebarNav keyValue={keyValue} handleKeyvalue={handleKeyvalue} />}

          <div style={{ width: keyValue === "7" ? "100%" : "93.3%" }}>
            {keyValue === "0" && <CartPage {...componentProps} />}

            {keyValue === "1" && (
              <ParkedBillsView
                filterdParkedList={filterdParkedList}
                parkedBillSearchInput={parkedBillSearchInput}
                handleParkedBillSearchInput={handleParkedBillSearchInput}
                searchParkedBill={searchParkedBill}
                selectedKeys={selectedKeys}
                retrieveParkedData={retrieveParkedData}
                discardParkedBill={discardParkedBill}
                handleExpand={handleExpand}
                setKeyValue={setKeyValue}
              />
            )}

            {keyValue === "2" && <CashManagementView cashManagementData={cashManagementData} setAddCashFlag={setAddCashFlag} setCashAddInFlag={setCashAddInFlag} />}

            {keyValue === "3" && (
              <SalesHistoryView
                // order history
                orderHistorySearchInputRef={orderHistorySearchInputRef}
                searchOrderHistory={searchOrderHistory}
                showOrderHistory={showOrderHistory}
                setOrderHistoryInput={setOrderHistoryInput}
                changeOrderHistorySearchType={changeOrderHistorySearchType}
                orderHistoryDetails={orderHistoryDetails}
                selectedKeys={selectedKeys}
                handleExpand={handleExpand}
                isPrintModeXML={isPrintModeXML}
                // return purchase
                showReturnPurchase={showReturnPurchase}
                setShowReturnPurchase={setShowReturnPurchase}
                searchReturnHistory={searchReturnHistory}
                dataSource={dataSource}
                columns1={columns1}
                handleSave={handleSave}
                setModalEditState={setModalEditState}
                modalEditState={modalEditState}
                selectedReturnOrder={selectedReturnOrder}
                returnProcessLoading={returnProcessLoading}
                setReturnProcessLoading={setReturnProcessLoading}
                addSelectedReturnProductsToCart={addSelectedReturnProductsToCart}
                returnProcessRef={returnProcessRef}
                cart={cart}
                productsList={productsList}
                setProductsList={setProductsList}
                loader={loader}
                salesHistoryLoading={salesHistoryLoading}
              />
            )}

            {keyValue === "7" && (
              <PaymentView
                paymentProcessFlag={paymentProcessFlag}
                cart={cart}
                tillData={tillData}
                paymentType={paymentType}
                selectedPaymentMethod={selectedPaymentMethod}
                setSelectedPaymentMethod={setSelectedPaymentMethod}
                amount={amount}
                onChangeAmount={onChangeAmount}
                paymentModalInputRef={paymentModalInputRef}
                paymentCardRef={paymentCardRef}
                requestPayment={requestPayment}
                processOrder={processOrder}
                handleAmount={handleAmount}
                handleKeyvalue={handleKeyvalue}
                productsList={productsList}
                setProductsList={setProductsList}
                paymentModalLoyalityMessages={paymentModalLoyalityMessages}
                selectProductInCart={selectProductInCart}
                setIsSearchProducts={setIsSearchProducts}
                selectedRowKeys={selectedRowKeys}
                selectedProductInCart={selectedProductInCart}
                setIsQtyUpdate={setIsQtyUpdate}
              />
            )}
          </div>
        </div>
        <RetailModals {...props} />
      </div>
    </Spin>
  );
};

export default PointOfSaleRetail;
